<!--
 * @Descripttion: 
 * @version: 
 * @Author: 杨海波
 * @Date: 2021-07-29 16:11:25
 * @LastEditors: 杨海波
 * @LastEditTime: 2021-11-29 09:56:13
 * @FilePath: /intell-loan/src/Input/index.vue
-->
<template>
  <div class="inputShell">
    <div class="inputBox">
      <span v-if="params.title" :class="`title ${params.field}`">{{ params.title }}</span>
      <div class="inputItem">
        <input
          class="inputContainer"
          :disabled="params.disabled"
          :placeholder="params.props.placeholder"
          :maxLength="params.props.maxLength"
          @input="changeInput"
          v-model="value"
          type="text"
          @blur="blurHandler()"
          @focus="focusHandler()"
        />
        <div class="error" :style="{ color: 'red' }" v-if="error">{{ error }}</div>
      </div>
    </div>

    <svg
      v-if="!params.disabled && allowClearHandler && value"
      viewBox="64 64 896 896"
      focusable="false"
      data-icon="close"
      width="1em"
      height="1em"
      fill="currentColor"
      class="allowClear"
      aria-hidden="true"
      @click="allowClear"
    >
      <path
        d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3
        5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4
        512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3
        3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"
      ></path>
    </svg>
  </div>
</template>

<script>

export default {
  name: 'Input',
  data() {
    return {
      value: '',
      error: '',
    };
  },
  props: ['params', 'errorMessage', 'allowClearHandler', 'form'],
  methods: {
    allowClear() {
      this.value = '';
      this.allowClearHandler();
    },
    changeInput(val) {
      this.value = this.params.field === 'iceContactIdentity' ? val.target.value.toUpperCase() : val.target.value;
    },
    // 手机号码展示转换
    phoneTransfrom(val) {
      if (!val) return;
      let value = val.replace(/\D/g, '').substr(0, 11); // 不允许输入非数字字符，超过11位数字截取前11位
      const len = value.length;
      if (len > 3 && len < 8) {
        value = value.replace(/^(\d{3})/g, '$1 ');
      } else if (len >= 8) {
        value = value.replace(/^(\d{3})(\d{4})/g, '$1 $2 ');
      }
      return value;
    },
    blurHandler() {
      // this.form.dispatch({
      //   type: 'upDateupDisabled',
      //   [this.params.field]: true,
      // });
      // 失去焦点之后判断 ，判断正则是否通过， 当前值与上一次请求的值是否相同
      if (!this.form.passThrough) {
        // if (IfSame(this.form.getState(), this.form.lastTimeParams)) {
        //   return;
        // };
        setTimeout(() => {
          this.form.lastTimeParams = this.form.getState();
        }, 3000);
      }
    },
    focusHandler() {
      setTimeout(() => {
        console.log(this.form.passThrough);
        if (!this.form.passThrough) {
          console.log('');
        }
      });
    },
  },
  watch: {
    value: {
      handler(val, oldVal) {
        if (oldVal !== val) {
          this.$emit('input', val);
        }
      },
    },
    'params.initValue': {
      handler(val) {
        if (val !== this.value) {
          this.value = val;
        }
      },
    },
    errorMessage: {
      handler(val) {
        this.error = val.message;
      },
    },
  },
};
</script>
<style scoped lang="scss">
.inputContainer {
  display: inline-block;
  border: none;
  font-size: 16px;
  flex: 1;
  padding: 0;
}
.allowClear {
  font-size: 14px;
  color: #999;
}
.inputShell {
  position: relative;
  padding: 10px 16px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.inputBox {
  background: #fff;
  flex: 1;
  display: flex;
  .inputItem {
    display: inline-block;
    position: relative;
    flex: 1;
    display: flex;
    .error {
      position: absolute;
      bottom: -11px;
    }
  }
}
.error {
  font-size: 12px;
}
.title {
  margin-right: 11px;
  font-size: 14px;
  color: #46494D;
  text-align: left;
  font-weight: 400;
  word-wrap: break-word;
  width: 86px;
}
input::-webkit-input-placeholder {
  color: #BCC2CC;
  font-size: 16px;
}
input::-moz-input-placeholder {
  color: #BCC2CC;
  font-size: 16px;
}
input::-ms-input-placeholder {
  color: #BCC2CC;
  font-size: 16px;
}
</style>
